import {
  getCardsByUser,
  createCardByUser,
  deleteCardByUser,
  updateCardByUser
} from '@/api/userCard.api'

const state = {
  isUserCardLoading: false,

  userCards: [],
}

const mutations = {
  setUserCards (state, userCards) {
    return state.userCards = userCards
  },

  setDefaultById (state, userCardId) {
    state.userCards.forEach(userCard => {
      userCard.default = (userCard.id == userCardId)
    })
  },

  resetUserCardDefaut (state) {
    const userCardDefault = state.userCards.find(userCard => userCard.default)

    if (!userCardDefault) {
      return null
    }

    userCardDefault.default = 0
  },

  addUserCard (state, userCard) {
    state.userCards.unshift(userCard)
  },

  removeUserCardById (state, userCardId) {
    const index = state.userCards.findIndex(userCard => {
      return userCard.id == userCardId
    })

    if (index == -1) return null

    state.userCards.splice(index, 1)
  },

  usetUserCardLoading (state, isLoading) {
    state.isUserCardLoading = isLoading
  },
}

const getters = {
  userCards ({ userCards }) {
    return userCards.sort((a, b) => b.default - a.default)
  },

  isUserCardLoading ({ isUserCardLoading }) {
    return isUserCardLoading
  },
}

const actions = {
  async createUserCard ({ commit }, data) {
    commit('usetUserCardLoading', true)

    try {
      const userCard = await createCardByUser('me', data)

      commit('resetUserCardDefaut')
      commit('addUserCard', userCard)

      commit('usetUserCardLoading', false)
    } catch (err) {
      commit('usetUserCardLoading', false)
      
      throw err
    }

  },

  async getCardsByUser ({ commit }) {
    commit('usetUserCardLoading', true)

    const userCards = await getCardsByUser('me')
    commit('setUserCards', userCards)

    commit('usetUserCardLoading', false)
  },

  async setDefaultById ({ commit }, userCardId) {
    commit('usetUserCardLoading', true)

    await updateCardByUser('me', userCardId, { default: true })

    commit('setDefaultById', userCardId)

    commit('usetUserCardLoading', false)
  },

  async removeUserCardById ({ commit }, userCardId) {
    commit('usetUserCardLoading', true)

    await deleteCardByUser('me', userCardId)

    commit('removeUserCardById', userCardId)

    commit('usetUserCardLoading', false)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
